// src/features/blogs/components/BlogCard.jsx
import { Link } from 'react-router-dom';

export default function BlogCard({ blog }) {
  const {
    title,
    slug,
    coverImageUrl,
    summary,
    publishedAt,
    tags = [],
    author,
  } = blog;

  return (
    <article className="rounded-2xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition">
      {coverImageUrl ? (
        <img
          src={coverImageUrl}
          alt={title}
          className="h-48 w-full object-cover rounded-t-2xl"
          loading="lazy"
        />
      ) : null}
      <div className="p-5">
        <div className="text-xs text-gray-500 mb-2">
          {publishedAt ? new Date(publishedAt).toLocaleDateString() : '—'} • {author ?? 'Editorial'}
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          <Link to={`/blogs/${slug}`} className="hover:opacity-80">{title}</Link>
        </h3>
        {summary ? <p className="text-gray-600 line-clamp-3">{summary}</p> : null}
        {Array.isArray(tags) && tags.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1">
            {tags.map((t) => (
              <span key={t} className="text-xs rounded-full border px-2 py-0.5 text-gray-600">
                #{t}
              </span>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}
